import { render, staticRenderFns } from "./Robots.vue?vue&type=template&id=e511a284&"
import script from "./Robots.vue?vue&type=script&lang=js&"
export * from "./Robots.vue?vue&type=script&lang=js&"
import style0 from "./Robots.vue?vue&type=style&index=0&id=e511a284&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports